'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _typography = require('web-makeup/dist/design-system/styles/typography');

var _url = require('../../../helpers/url');

var _brandSubHeader = require('./brand-sub-header.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BrandSubHeader = function BrandSubHeader(_a) {
    var active = _a.active;
    return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_brandSubHeader.NavWrapper, null, _react2.default.createElement(_brandSubHeader.NavInnerWrapper, null, _react2.default.createElement(_brandSubHeader.Nav, { active: active }, _react2.default.createElement(_typography.Text, { as: "div", fontSize: "h4", textAlign: "center", color: "black1" }, _react2.default.createElement("a", { href: (0, _url.getBrandAppUrl)() + "/newfoundation/new-services" }, "Service")), _react2.default.createElement(_typography.Text, { as: "div", fontSize: "h4", textAlign: "center", color: "black1" }, _react2.default.createElement("a", { href: (0, _url.getBrandAppUrl)() + "/newfoundation/solutions" }, "Solutions"))))));
};
exports.default = BrandSubHeader;
//# sourceMappingURL=brand-sub-header.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/components/brand-sub-header/brand-sub-header.js
// module id = 1921
// module chunks = 0